module.exports = __webpack_public_path__ + "static/media/coding-lesson-plans.4b51fb9d.png";